export default __webpack_public_path__ + "static/media/SourceSansPro-BoldItalic.2227e84d.ttf";